var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFavoriteMain = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.827 25.6856C15.3737 25.8456 14.627 25.8456 14.1737 25.6856C10.307 24.3656 1.66699 18.8589 1.66699 9.5256C1.66699 5.4056 4.98699 2.07227 9.08032 2.07227C11.507 2.07227 13.6537 3.2456 15.0003 5.05893C15.6854 4.13343 16.5776 3.38123 17.6057 2.86259C18.6337 2.34395 19.7689 2.07328 20.9203 2.07227C25.0137 2.07227 28.3337 5.4056 28.3337 9.5256C28.3337 18.8589 19.6937 24.3656 15.827 25.6856Z",
    stroke: "#00AAE5",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavoriteMain, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/favorite-main.0cd08962.svg";
export { ForwardRef as ReactComponent };